module.exports = __webpack_public_path__ + "static/img/course_selection_widget_1.4ad9fe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/course_selection_widget_1.png
// module id = WvDG
// module chunks = 11